import Menu from './Compartido/Menu.jsx';
import TextosFaqs from './Faqs/TextosFaqs.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Faqs = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="6_Faqs"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextosFaqs
                lang={props.lang}
                faqs={props.faqs}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Faqs;

